import { CSSProperties } from "react";

const ChevronIcon = ({
  scale,
  rotate,
  color,
  style,
}: {
  scale?: number;
  rotate?: "left" | "right" | "top";
  color?: string;
  style?: CSSProperties;
}) => {
  let c = "#878787";
  if (color) c = color;
  return (
    <svg
      className={`chevron ${rotate || ""}`}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transition: "ease-in-out 300ms",
        ...style,
      }}
    >
      <path
        d="M12.7662 6.32504C12.7662 6.43065 12.7238 6.53636 12.6392 6.61698L8.30639 10.7463C8.13708 10.9076 7.86292 10.9076 7.69372 10.7463L3.36087 6.61698C3.19156 6.45563 3.19156 6.19435 3.36087 6.0331C3.53017 5.87185 3.80433 5.87174 3.97353 6.0331L8.00005 9.87046L12.0266 6.0331C12.1959 5.87174 12.47 5.87174 12.6392 6.0331C12.7238 6.11372 12.7662 6.21943 12.7662 6.32504Z"
        fill={c}
      />
    </svg>
  );
};

export default ChevronIcon;
